import { useEncryptStore } from "@/store/useEncryptStore";
import { useApi } from "@/composables/useApi";

export const useDb = () => {
  const { encrypt, decrypt } = useEncryptStore();
  const api = useApi();

  const generateRandomKey = () => {
    const array = new Uint8Array(32)
    crypto.getRandomValues(array)
    return Array.from(array, b => b.toString(16).padStart(2, '0')).join('')
  }

  const createDoc = async (path, value, key) => {
    try {
      const encrypted = await encrypt(JSON.stringify(value), key);
      const result = await api.post(`/api/docs/${path}`, {
        doc: encrypted,
        validUntil: value.validUntil,
      });
      if (result.error) throw new Error(result.error);
      return result.id;
    } catch (e) {
      throw new Error(`No se pudo guardar en ${path}: ${e.message}`);
    }
  };

  const readDoc = async (userId, path, id, key) => {
    try {
      const result = await api.get(`/api/docs/${userId}/${path}/${id}`);
      if (result.error) return { data: null, error: result.error };
      const decrypted = await decrypt(result.doc, key);
      return { data: JSON.parse(decrypted), error: null };
    } catch {
      return { data: null, error: "Estos datos ya no están disponibles" };
    }
  };

  return { createDoc, readDoc, generateRandomKey };
};
